module.exports = __webpack_public_path__ + "img/logo.4294b6b8.jpg";